import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  CircularProgress,
  Avatar,
  Fade,
  Paper,
  Button
} from '@mui/material';
import {
  Schedule as ScheduleIcon,
  Analytics as AnalyticsIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';

const AnalysisProgressTracker = ({ taskProgress, isAnalyzing, onCancel }) => {
  if (!isAnalyzing || !taskProgress) {
    return null;
  }

  const message = taskProgress.message === 'Task queued for processing'
    ? 'Задача поставлена в очередь на обработку'
    : (taskProgress.message || 'Обработка компаний с помощью искусственного интеллекта');

  return (
    <Dialog
      open={isAnalyzing}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
        }
      }}
    >
      <DialogContent sx={{ p: 4 }}>
        <Fade in={isAnalyzing}>
          <Box sx={{ textAlign: 'center' }}>
            {/* Заголовок */}
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
              <Avatar sx={{ bgcolor: 'primary.main', width: 56, height: 56, mr: 2 }}>
                <AnalyticsIcon sx={{ fontSize: 32 }} />
              </Avatar>
              <Box sx={{ textAlign: 'left' }}>
                <Typography variant="h5" fontWeight="600" gutterBottom>
                  Анализ компаний в процессе
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {message}
                </Typography>
              </Box>
            </Box>

            {/* Спиннер */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
              <CircularProgress size={72} thickness={3} />
            </Box>

            {/* Статус сообщение */}
            <Paper
              elevation={0}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2.5,
                bgcolor: 'primary.main',
                borderRadius: 2,
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.15)',
                mb: 2
              }}
            >
              <ScheduleIcon sx={{ mr: 1.5, color: 'white', fontSize: 24 }} />
              <Typography variant="body1" color="white" fontWeight="500">
                Пожалуйста, не закрывайте страницу. Это может занять некоторое время.
              </Typography>
            </Paper>

            {/* Кнопка отмены */}
            {onCancel && (
              <Button
                variant="outlined"
                color="error"
                startIcon={<CancelIcon />}
                onClick={onCancel}
                sx={{ mt: 1 }}
              >
                Отменить поиск
              </Button>
            )}
          </Box>
        </Fade>
      </DialogContent>
    </Dialog>
  );
};

export default AnalysisProgressTracker;
